import React from 'react';
import { usePets } from '../../../hooks/usePets';
import { PetGrid } from './PetGrid';
import type { User } from '../../../types/user';

interface PetInventoryProps {
  user: User | null;
}

export function PetInventory({ user }: PetInventoryProps) {
  const { userPets, loading, error } = usePets(user?.walletAddress);

  if (!user) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">Please log in to view your pets</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-400 text-center py-12">
        {error}
      </div>
    );
  }

  if (userPets.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">Your stables are empty. Visit the marketplace to acquire pets!</p>
      </div>
    );
  }

  return <PetGrid pets={userPets} />;
}